// Fire-and-forget client-side player-error telemetry sink (Phase 0 of the
// video-enhancement plan). Shared by the React players (LessonRecording,
// WebinarRecording); the legacy webpacker Stimulus player carries its own inline
// copy because the two build trees do not share source.
//
// The per-session cap prevents an error loop (video.js can re-error on retry)
// from self-DDoSing the endpoint from a single stuck tab.
const MAX_REPORTS_PER_SESSION = 5;
let reportsSent = 0;

export const reportPlayerError = (payload) => {
  if (reportsSent >= MAX_REPORTS_PER_SESSION) return;
  reportsSent += 1;

  const body = JSON.stringify({
    ...payload,
    page_path: window.location.pathname,
  });

  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      "/api/player_errors",
      new Blob([body], { type: "application/json" }),
    );
    return;
  }

  fetch("/api/player_errors", {
    body,
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    method: "POST",
  });
};
